import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import weekDays from "data/weekDays";
import { convertTime12to24, timeStringToFloat } from "helpers/timeStringToFloat";
import SearchSelect from "../../common/SearchSelect";

const AvailabilityTable = (props) => {
    const timeFormat = "h:mm A";

    const {
        data,
        onChangeTime,
        onChangeHours
    } = props;

    const [availability, setAvailability] = useState(data || {});
    const [timeList, setTimeList] = useState([]);
    const [timeRanges, setTimeRanges] = useState(new Map());
    const [rangeSizes, setRangeSizes] = useState(new Map());
    const [rangeValues, setRangeValues] = useState(new Map());

    useEffect(() => {
        const interval = 30;
        const times = [];
        let startTime = 0;
        const format = [" AM", " PM"];
        const zero = "0";

        // eslint-disable-next-line no-plusplus
        for (let i = 0; startTime < 24 * 60; i++) {
            const currentTime = {};
            const hh = Math.floor(startTime / 60);
            const mm = (startTime % 60);
            let to12Hour = hh % 12;
            if (to12Hour === 0) to12Hour = 12;
            currentTime.label = `${(to12Hour).toString().slice(-2)}:${(zero + mm).slice(-2)}${format[Math.floor(hh / 12)]}`;
            currentTime.value = moment(`${convertTime12to24(currentTime.label)}:00`, timeFormat);
            startTime += interval;
            times.push(currentTime);
        }
        setTimeList(times.slice(12));
    }, []);

    useEffect(() => {
        setAvailability(data);
        // eslint-disable-next-line no-restricted-syntax,no-use-before-define
        calculateRanges(data);
    }, [data]);
    const onChangeHandler = (index, type, value) => {
        const currentData = data[index];
        let startTime;
        let endTime;
        if (type === "start") {
            startTime = moment(value).format(timeFormat);
            endTime = currentData.end;
        }
        if (type === "end") {
            startTime = currentData.start;
            endTime = moment(value).format(timeFormat);
        }

        const startTimeFloat = timeStringToFloat(convertTime12to24(startTime || ""));
        const endTimeFloat = timeStringToFloat(convertTime12to24(endTime || ""));
        if (startTimeFloat > endTimeFloat) return;
        const rangeSize = (endTime ? endTimeFloat : 24)
            - (startTime ? startTimeFloat : 0);

        if (rangeValues.get(index) > rangeSize) onChangeHours(index, "availableHours", rangeSize);

        onChangeTime(index, type, value);
    };
    const calculateRanges = data => {
        // eslint-disable-next-line no-restricted-syntax
        for (const [key, value] of Object.entries(data)) {
            const ranges = [];

            const rangeSize = (
                value.end
                    ? timeStringToFloat(
                    convertTime12to24(
                        value.end
                    )
                    )
                    : 24
            ) - (
                value.start
                    ? timeStringToFloat(
                    convertTime12to24(
                        value.start
                    )
                    )
                    : 0
            );
            for (let i = 0; i <= rangeSize; i += 0.5) {
                ranges.push({ label: i.toString(), value: i });
            }
            timeRanges.set(key, ranges);
            rangeSizes.set(key, rangeSize);
            rangeValues.set(key, value.availableHours);
        }
        setTimeRanges(timeRanges);
        setRangeSizes(rangeSizes);
        setRangeValues(rangeValues);
    };

    return (
        <table className="table table-condensed table-bordered table-hover">
            <thead>
            <tr>
                <th>Day of week</th>
                <th>Start Time</th>
                <th>End Time</th>
                <th>Hours</th>
            </tr>
            </thead>
            <tbody>
            {Object.keys(availability)
                .map(index => (
                    <tr key={index}>
                        <td>{weekDays[index]}</td>
                        <td>
                            <SearchSelect
                                className="custom-react-select"
                                isLoading={false}
                                isClearable={false}
                                options={timeList}
                                value={timeList.find(item =>
                                    item.value === availability[index].start
                                    || item.label === availability[index].start)}
                                onChange={time => onChangeHandler(index, "start", time.value)}
                            />
                        </td>
                        <td>
                            <SearchSelect
                                className="custom-react-select"
                                isLoading={false}
                                isClearable={false}
                                options={timeList}
                                value={timeList.find(item =>
                                    item.value === availability[index].end
                                    || item.label === availability[index].end)}
                                onChange={time => onChangeHandler(index, "end", time.value)}
                            />
                        </td>
                        <td>
                            <SearchSelect
                                className="custom-react-select"
                                isLoading={false}
                                isClearable={false}
                                options={timeRanges.get(index)}
                                placeholder={"placeholder"}
                                value={availability[index].start !== null &&
                                availability[index].end !== null &&
                                availability[index].desiredHours === 0 ? { label: "0", value: 0 }
                                : { label: availability[index].desiredHours.toString(),
                                    value: availability[index].desiredHours } || ""}
                                onChange={time => {
                                    rangeSizes.set(index, time.value);
                                    setRangeValues(rangeValues);
                                    onChangeHours(index, "desiredHours", time.value);
                                }}
                            />
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

AvailabilityTable.propTypes = {
    data: PropTypes.object.isRequired,
    onChangeTime: PropTypes.func.isRequired,
    onChangeHours: PropTypes.func.isRequired,
};

export default AvailabilityTable;
